import type { ReleasePr } from '../api/releases'
import { workflowBlockerText, type OwnerMode, type OwnerResult } from './workflowOwner.ts'
export function releaseDecisionReason(mode:OwnerMode,now=new Date()){
  return `אושר ע״י ניצן — ${mode==='night'?'לילה':'עכשיו'} · ${now.toLocaleDateString('he-IL',{timeZone:'Asia/Jerusalem'})}`
}
export function releaseDecisionGates(pr:ReleasePr,result?:OwnerResult|null):string[]{
  const gates:string[]=[]
  if(pr.control_snapshot?.head_sha!==pr.head_sha||pr.control_snapshot?.checks_green!==true)gates.push('בדיקות שחרור')
  if(pr.control_snapshot?.head_sha!==pr.head_sha||pr.control_snapshot?.risk_reference_unverified)gates.push('אימות סיכון')
  if(pr.merge_state?.toLowerCase()==='dirty')gates.push('פתרון קונפליקטים')
  const blocker=pr.workflow_blocker
  if(blocker&&!(blocker.code==='draft'&&!pr.draft)&&!['owner_approval','screens_approval','task_not_reviewed'].includes(blocker.code))gates.push(blocker.text)
  if(pr.workflow?.reason&&pr.workflow.reason!=='preflight_pending')gates.push(workflowBlockerText(pr.workflow.reason))
  gates.push(...(result?.blockers??[]).filter(c=>c!=='task_not_reviewed').map(workflowBlockerText))
  if(result?.mirror_pending)gates.push('אימות רישום האישור בחדר הבקרה')
  return [...new Set(gates)]
}
